<template>
  <div class="page-wrap">
    <div class="bg-overlay" />

    <v-card
      elevation="0"
      variant="flat"
      class="mx-auto main-card"
      max-width="440"
    >
      <div class="card-top" />

      <v-card-text class="pa-8">
        <v-img
          class="mx-auto mb-4"
          height="60"
          max-width="150"
          src="./logo.png"
        />

        <div class="text-center mb-1">
          <span class="main-text">Reset Password</span>
        </div>
        <p class="sub-text text-center mb-6">
          Enter your email and we'll send you a link to reset your password.
        </p>

        <v-form ref="resetForm" v-model="isValid">
          <span class="field-label">Email</span>
          <v-text-field
            class="mt-2"
            ref="email"
            :rules="rules.required"
            v-model="formData.email"
            density="comfortable"
            placeholder="you@example.com"
            variant="outlined"
            rounded="lg"
            prepend-inner-icon="mdi-email-outline"
          />
        </v-form>

        <v-btn
          @click="Request()"
          :loading="loading"
          :disabled="loading"
          block
          height="46"
          class="text-none text-subtitle-1 mt-2 request-btn"
          elevation="0"
        >
          <v-icon class="mr-2">mdi-account-convert</v-icon>
          Request Reset Link
        </v-btn>

        <v-btn
          :to="{ name: 'signIn' }"
          block
          text
          class="text-none text-subtitle-1 mt-3"
          color="#50568e"
          variant="text"
        >
          <v-icon class="mr-1" size="18">mdi-arrow-left</v-icon>
          Back to Login
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="380" persistent>
      <v-card class="pa-6 text-center wait-card" elevation="8" rounded="lg">
        <p class="mb-4 font-weight-medium">
          Redirecting you back to the login page…
        </p>
        <div class="dots mb-4">
          <span
            v-for="n in 5"
            :key="n"
            class="ball"
            :style="{ animationDelay: `${n * 0.12}s` }"
          />
        </div>
        <v-progress-linear color="#50568e" indeterminate rounded height="4" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "testPage",

  data() {
    return {
      dialog: false,
      isValid: false,
      loading: false,
      loginState: false,
      screenSize: "",
      visible: false,
      formData: {
        email: "",
      },
      showPassword: false,
      rules: {
        required: [(value) => !!value || "Required."],
        email: [
          (value) => !!value || "Required.",
          (value) => /.+@.+\..+/.test(value) || "Invalid email address.",
        ],
        password: [(value) => !!value || "Required."],
      },
    };
  },

  computed: {},

  mounted() {},
  methods: {
    async Request() {
      if (!this.isValid) {
        this.$refs.resetForm.validate();
        return;
      }

      this.loading = true;
      try {
        await this.$store.dispatch("auth/forgot", this.formData);
      } finally {
        this.loading = false;
      }
    },
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
  },

  watch: {},
};
</script>

<style scoped>
/* @import url("../authStyle.css"); */

.page-wrap {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-image: url("https://images.unsplash.com/photo-1643845892686-30c241c3938c?q=80&w=688&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover;
  background-position: center;
}

.bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(46, 43, 82, 0.55),
    rgba(80, 86, 142, 0.45)
  );
}

.main-card {
  position: relative;
  z-index: 1;
  width: 100%;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25) !important;
}

.card-top {
  height: 6px;
  background: linear-gradient(90deg, #50568e, #7b81c4);
}

.main-text {
  font-size: 22px;
  font-weight: 700;
  color: #2e2b52;
}

.sub-text {
  font-size: 13.5px;
  color: #7a7a8c;
  line-height: 1.4;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #3c3731;
}

.request-btn {
  background: #50568e !important;
  color: #fff !important;
  border-radius: 10px !important;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.request-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(80, 86, 142, 0.3) !important;
}

.wait-card {
  border-radius: 14px;
}

.dots {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.ball {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #50568e;
  animation: bounce 1s infinite ease-in-out;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
